import { Box } from '@chakra-ui/react';
import { KText } from 'ui-library/components';
import { OutreachSearchItem } from '../item/OutrachSearchItem';

export const OutreachList = ({ outreachData, searchTerm }) => {
  return (
    <Box>
      <KText
        textTransform="uppercase"
        lineHeight="26px"
        letterSpacing="1px"
        px="16px"
        mb="md"
        size="sm-medium"
        color="secondary-900"
      >
        flow results
      </KText>
      {outreachData?.data?.outreaches.map((outreach, index) => {
        return (
          <OutreachSearchItem
            searchTerm={searchTerm}
            key={outreach.id}
            outreach={outreach}
            showBorderBottom={
              index !== outreachData?.data?.outreaches?.length - 1
            }
          />
        );
      })}
    </Box>
  );
};
